import moment from "moment";

/**
 * callCredits accepts a DID service
 *
 * @param service
 * @returns {{minutes: number, daysLeft: number}}
 */
const callCredits = (service) => {
    if (typeof(service) === 'undefined') {
        return {minutes: 0, daysLeft: 0}
    }

    const minutes = service.callCredits || 0;

    // Calculate the number of days to expiry
    const e = moment(service.callCreditsExpiry);   // expected that it will be in the future
    const today = moment().startOf('day');
    let days = Math.round(moment.duration(e - today).asDays())
    if (days < 0) {
        days = 0
    }
    // If we're out call credits, we have no days left
    const daysLeft = minutes > 0 ? days : 0;

    return { minutes, daysLeft }
}

export default callCredits;